<div *ngIf="blocked" style="width: 100%; text-align: center">
  <h1>{{ "ALERT_INACTIVE_SESSION" | translate }}</h1>
  <button
    pButton
    label="{{ 'LOGIN' | translate }}"
    icon="pi pi-sign-in"
    (click)="logout()"
    style="width: 100%"
  ></button>
</div>

<ng-container *ngIf="!blocked">
  <div
    class="shadow-3 p-3 flex align-items-center header-nav"
    [class.header-nav--standalone]="minimalStandaloneShell"
  >
    <div class="flex align-items-center" (click)="goToHomeUnlessStandalone()">
      <div class="logo-client-container" *ngIf="clientLogoUrl">
        <div class="servolab-logo">
          <img src="/assets/img/logo-servolab.png" alt="Servolab Logo" />
          <h5 class="app-title">
            <div>
              {{ "APP_TITLE_1" | translate }}
            </div>
            <div>
              {{ "APP_TITLE_2" | translate }} <small>v.{{ version }}</small>
            </div>
          </h5>
        </div>
        <div class="client-logo-container">
          <img
            class="client-logo"
            [src]="clientLogoUrl"
            [ngStyle]="{ height: legalNotice ? '35px' : '45px' }"
            [alt]="'Client Logo'"
          />
          <div
            class="legal-notice"
            *ngIf="legalNotice"
            (click)="showLegalNotice = true; $event.stopPropagation()"
          >
            {{ "LEGAL_NOTICE" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <div *ngIf="hasUserGuide">
        <i class="pi pi-question-circle" (click)="downloadUserGuide()"></i>
      </div>

      <div *ngIf="showCenterSelector && !minimalStandaloneShell">
        <i class="pi pi-home" (click)="goToHome()"></i>
      </div>

      <div
        class="center-picker"
        *ngIf="showEditableHeaderCenter"
      >
        <div class="center-picker-label">
          {{ "WEB_RESULTS.HEADER.CENTER" | translate }}
        </div>
        <div class="center-picker-select">
          <select
            [(ngModel)]="selectedCenter"
            (change)="onCenterChange($event)"
          >
            <option *ngIf="!selectedCenter" [value]="null">
              {{ "SELECT_CENTER" | translate }}
            </option>
            <option *ngFor="let center of centers" [value]="center.centroId">
              {{ center.centroName }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="center-picker center-picker--readonly"
        *ngIf="showReadonlyHeaderCenter"
      >
        <div class="center-picker-label">
          {{ "WEB_RESULTS.HEADER.CENTER" | translate }}
        </div>
        <div class="center-picker-select center-picker-readonly">
          {{ readonlyHeaderCenterName }}
        </div>
      </div>
      <div class="user-info">
        <i class="pi pi-user" (click)="goToHomeUnlessStandalone()"></i>
        <div>{{ username }}</div>
      </div>
      <div>
        <i class="pi pi-sign-out" (click)="logout()"></i>
      </div>
    </div>
  </div>

  <div class="main-container">
    <div class="sidebar-container" *ngIf="showMenu()">
      <p-button (onClick)="toggleMenu()" icon="pi pi-ellipsis-v" />
      <p-tieredMenu
        [model]="menuItems"
        [popup]="!menuVisible"
        #tieredMenu
        [style]="{ width: '200px' }"
        [baseZIndex]="10000"
      ></p-tieredMenu>
    </div>

    <div class="content-outer">
      <div class="state-indicator" *ngIf="isFetching">
        <p-progressBar
          mode="indeterminate"
          [style]="{ height: '6px' }"
        ></p-progressBar>
      </div>
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Dialog legal notice -->
  <p-dialog
    header="{{ 'LEGAL_NOTICE' | translate }}"
    [modal]="true"
    [(visible)]="showLegalNotice"
    [style]="{ width: '90%' }"
  >
    <div [innerHTML]="legalNotice"></div>
    <div class="flex justify-content-end">
      <p-button
        label="{{ 'CLOSE' | translate }}"
        icon="pi pi-times"
        (click)="showLegalNotice = false"
      ></p-button>
    </div>
  </p-dialog>
</ng-container>
